export default __webpack_public_path__ + "static/media/330_dummy2016-cafe01-mobile-de.66b60963.png";